<template>
<div class="chapter">
<div class="inner_page">
<p class="P_TOC_Heading" id="tableofcontents">Table of Contents</p>
<p class="P_TOC_Entry_1"><a href="#/section0002#auto_bookmark_table_of_contents_1">Blurb</a></p>
<p class="P_TOC_Entry_1"><a href="#/section0003#auto_bookmark_table_of_contents_1">Dedication</a></p>
<p class="P_TOC_Entry_1"><a href="#/section0004#auto_bookmark_table_of_contents_1">Acknowledgments</a></p>
<p class="P_TOC_Entry_1"><a href="#/section0005#auto_bookmark_table_of_contents_1">Author’s Note</a></p>
<p class="P_TOC_Entry_1"><a href="#/section0006#auto_bookmark_table_of_contents_1">Prologue</a></p>
<p class="P_TOC_Entry_1"><a href="#/section0006#auto_bookmark_table_of_contents_2">Unexpected Cargo</a></p>
<p class="P_TOC_Entry_1"><a href="#/section0007#auto_bookmark_table_of_contents_1">Meanwhile, back in Sacramento….</a></p>
<p class="P_TOC_Entry_1"><a href="#/section0008#auto_bookmark_table_of_contents_1">Oops, Here I Go Again….</a></p>
<p class="P_TOC_Entry_1"><a href="#/section0009#auto_bookmark_table_of_contents_1">Fish in a School</a></p>
<p class="P_TOC_Entry_1"><a href="#/section0010#auto_bookmark_table_of_contents_1">Two Fish, One Pond</a></p>
<p class="P_TOC_Entry_1"><a href="#/section0011#auto_bookmark_table_of_contents_1">Big Fish, Little Fish</a></p>
<p class="P_TOC_Entry_1"><a href="#/section0012#auto_bookmark_table_of_contents_1">A Familiar Pond</a></p>
<p class="P_TOC_Entry_1"><a href="#/section0013#auto_bookmark_table_of_contents_1">Worms and Hooks</a></p>
<p class="P_TOC_Entry_1"><a href="#/section0014#auto_bookmark_table_of_contents_1">Big Fish Walking</a></p>
<p class="P_TOC_Entry_1"><a href="#/section0015#auto_bookmark_table_of_contents_1">Extra Credit</a></p>
<p class="P_TOC_Entry_1"><a href="#/section0016#auto_bookmark_table_of_contents_1">A Little Chum</a></p>
<p class="P_TOC_Entry_1"><a href="#/section0017#auto_bookmark_table_of_contents_1">Ducks, Row, Truck</a></p>
<p class="P_TOC_Entry_1"><a href="#/section0018#auto_bookmark_table_of_contents_1">Fish Bowls in the Air</a></p>
<p class="P_TOC_Entry_1"><a href="#/section0019#auto_bookmark_table_of_contents_1">Swimming Fury</a></p>
<p class="P_TOC_Entry_1"><a href="#/section0020#auto_bookmark_table_of_contents_1">Fish in a Bulletproof Bowl</a></p>
<p class="P_TOC_Entry_1"><a href="#/section0021#auto_bookmark_table_of_contents_1">The Early Morning Coffee Swim</a></p>
<p class="P_TOC_Entry_1"><a href="#/section0022#auto_bookmark_table_of_contents_1">It Takes a Fish Bowl to Save a School of Fish</a></p>
<p class="P_TOC_Entry_1"><a href="#/section0023#auto_bookmark_table_of_contents_1">One Last Dirty Stinking Crappie</a></p>
<p class="P_TOC_Entry_1"><a href="#/section0024#auto_bookmark_table_of_contents_1">R.O.R.</a></p>
<p class="P_TOC_Entry_1"><a href="#/section0025#auto_bookmark_table_of_contents_1">Tails, Scales, and Epic Fails</a></p>
<p class="P_TOC_Entry_1"><a href="#/section0026#auto_bookmark_table_of_contents_1">Belly Up or Still Swimming</a></p>
<p class="P_TOC_Entry_1"><a href="#/section0027#auto_bookmark_table_of_contents_1">Fishy-versary</a></p>
<p class="P_TOC_Entry_1"><a href="#/section0029#auto_bookmark_table_of_contents_1">Cold Water</a></p>
<p class="P_TOC_Entry_1"><a href="#/section0032#auto_bookmark_table_of_contents_1">That One Shirt</a></p>
<p class="P_TOC_Entry_1"><a href="#/section0033#auto_bookmark_table_of_contents_1">When Dave Met Alex—</a></p>
<p class="P_TOC_Entry_1"><a href="#/section0037#auto_bookmark_table_of_contents_1">More from Amy Lane</a></p>
<p class="P_TOC_Entry_1"><a href="#/section0038#auto_bookmark_table_of_contents_1">Readers love the Fish Out of Water series by Amy Lane</a></p>
<p class="P_TOC_Entry_1"><a href="#/section0039#auto_bookmark_table_of_contents_1">About the Author</a></p>
<p class="P_TOC_Entry_1"><a href="#/section0040#auto_bookmark_table_of_contents_1">By Amy Lane</a></p>
<p class="P_TOC_Entry_1"><a href="#/section0041">Visit Dreamspinner Press</a></p>
<p class="P_TOC_Entry_1"><a href="#/section0042#auto_bookmark_table_of_contents_1">Copyright</a></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// section-0001.vue?accca960